import { useEffect, useState } from "react";
import { getApplicationManageData } from "../../../utility/application-data";
import { GratitudeComponentApplicationStateCriteriaEnum } from "../../../utility/constants/application-status";
import { isSalesforceApplication } from "../../../helpers/url-params";

export type GratitudeComponentStatusCriteriaType = keyof typeof GratitudeComponentApplicationStateCriteriaEnum;

export const useApplicationState = (applicationId: string) => {
  const [applicationState, setApplicationState] = useState<string>("");

  const applicationRequest = async () => {
    try {
      const request = await getApplicationManageData(applicationId);
      setApplicationState(request?.applicationState as string);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!isSalesforceApplication(applicationId)) {
      applicationRequest();
    }
  }, []);

  return applicationState as GratitudeComponentStatusCriteriaType;
};
